import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import FormInputField from './FormInputField'

class EmailField extends React.Component {
  showAsInvalid(message = null) {
    this.componentField.showAsInvalid(message)
  }

  render() {
    const {
      inputId,
      inputName,
      onChange,
      t,
      value
    } = this.props

    return (
      <FormInputField
        inputId={inputId}
        inputName={inputName}
        inputType="email"
        labelText={t('fields.email', { ns: 'devise' })}
        onChange={(event) => onChange(event)}
        ref={(component) => { this.componentField = component }}
        value={value}
      />
    )
  }
}

EmailField.propTypes = {
  inputId: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
}

export default withTranslation('devise', { withRef: true })(EmailField)
